import { t } from 'i18next';
import React from 'react';

const Error404Page: React.FC = () => {

    return (
        <div className="kt-body">
            <div className="kt-panel">
                <div className="kt-panel-content">
                    <h1>{t("pages.error404Page.somethingWentWrong")}</h1>
                    <h2>{t("pages.error404Page.couldNotFindPage")}</h2>
                    <h2>{t("pages.error404Page.pleaseCheckUrl")}</h2>
                </div>
            </div>
        </div>
    );
}

export default Error404Page;